// src/config/modules.js
// Catálogo central de módulos (tarjetas) y dashboards.

const SISENSE_HOST = process.env.REACT_APP_SISENSE_HOST;

/**
 * Cada módulo crea una tarjeta en Home y una ruta /m/:moduleSlug
 * Cada dashboard dentro de un módulo es /m/:moduleSlug/:dashboardSlug
 *
 * Para módulos externos (sin dashboards), usa:
 *   { external: true, externalUrl: "https://..." }
 * y la tarjeta debe abrir en una pestaña nueva.
 */
export const modules = [
  {
    slug: "venta-proveedor",
    title: "Venta Proveedor",
    icon: "💰",
    color: "#4F46E5", // indigo-600
    description:
      "Seguimiento de ventas por proveedor con vistas de categoría, producto y sucursal, incluyendo tendencias y comparativos.",
    host: SISENSE_HOST,
    defaultDashboard: "categoria",
    dashboards: [
      { slug: "categoria", title: "Categoría", sisenseDashboardId: "59c1560784b1c418206a4a9f" },
      { slug: "tendencia", title: "Tendencia", sisenseDashboardId: "59bffd9b685ecf0fa0d275d5" },
      { slug: "producto", title: "Producto", sisenseDashboardId: "5dfa9ef42d3a83002b73b95a" },
      { slug: "sucursal", title: "Sucursal", sisenseDashboardId: "5a6f415e93a9991810707c42" },
    ],
  },
  {
    slug: "share-unisuper",
    title: "Share Unisuper",
    icon: "📤",
    color: "#C026D3", // fuchsia-600
    description:
      "Participación de mercado interna: cuota por categoría, producto y tienda, con detección de oportunidades de crecimiento.",
    dashboards: [
      { slug: "categoria", title: "Categoría", sisenseDashboardId: "5dfb807eaf80ce37d0547484" },
      { slug: "tendencia", title: "Tendencia", sisenseDashboardId: "5deecd342b3d62002bce3e20" },
      { slug: "producto", title: "Producto", sisenseDashboardId: "5dfb97940fe64e002b191a3a" },
      { slug: "sucursal", title: "Sucursal", sisenseDashboardId: "5dfb99c20fe64e002b191a4c" },
      { slug: "oportunidad", title: "Oportunidad", sisenseDashboardId: "59ee56b458081f1804420d29" },
    ],
  },
  {
    slug: "margen-ponderado",
    title: "Margen Ponderado",
    icon: "➗",
    color: "#6D28D9", // violet-700
    description:
      "Análisis de rentabilidad mediante margen ponderado: evolución, mezcla por categoría y detalle por producto.",
    dashboards: [
      { slug: "tendencia", title: "Tendencia", sisenseDashboardId: "5a32ab1e019b0a19442c4fb0" },
      { slug: "categoria", title: "Categoría", sisenseDashboardId: "5a3401ef8f7c791834eb153c" },
      { slug: "producto", title: "Producto", sisenseDashboardId: "5a330fc4019b0a19442c77ff" },
    ],
  },
  {
    slug: "analisis-promociones",
    title: "Análisis de Promociones",
    icon: "📊",
    color: "#0284C7", // sky-600
    description:
      "Evaluación de campañas: uplift, efectividad y canibalización por categoría y periodo para optimizar inversiones.",
    dashboards: [
      { slug: "categoria", title: "Categoría", sisenseDashboardId: "5dfc0a0d73cf33002bdd822c" },
      { slug: "tendencia", title: "Tendencia", sisenseDashboardId: "5deeaf012b3d62002bce3d8f" },
    ],
  },
  {
    slug: "finanzas",
    title: "Finanzas",
    icon: "💵",
    color: "#059669", // emerald-600
    description:
      "Monitoreo financiero de vales y pagos: evolución, saldos, conciliaciones y control operativo.",
    dashboards: [
      { slug: "evolucion-de-vales", title: "Evolución de Vales", sisenseDashboardId: "5a219c48714bea0b68561a3f" },
      { slug: "vales", title: "Vales", sisenseDashboardId: "5a219c59714bea0b68561a59" },
      { slug: "pagos", title: "Pagos", sisenseDashboardId: "5a2025db059cc71820c49648" },
    ],
  },
  {
    slug: "abasto",
    title: "Abasto",
    icon: "📦",
    color: "#D97706", // amber-600
    description:
      "Salud del inventario y del abastecimiento: existencias, coberturas por cadena y sucursal, fill rate y revisión de OCs.",
    dashboards: [
      { slug: "existencia", title: "Existencia", sisenseDashboardId: "5dfbfa6f73cf33002bdd8180" },
      { slug: "cobertura-cadena", title: "Cobertura Cadena", sisenseDashboardId: "59f74c4342b3bcebae8be403" },
      { slug: "cobertura-sucursal", title: "Cobertura Sucursal", sisenseDashboardId: "59f8a10e6bd92c202cc9d896" },
      { slug: "fill-rate", title: "Fill Rate", sisenseDashboardId: "625db28f5653fb00369ec6f0" },
      { slug: "calendario-inventarios", title: "Calendario Inventarios", sisenseDashboardId: "6a837cc5d5426de3053c2372" },
      { slug: "revision-OC", title: "Revisión OC", sisenseDashboardId: "62d172a212a78b0036ea66f9" },
      { slug: "revision-OC-especial", title: "Revisión OC Especial", sisenseDashboardId: "63fdf20a1083cf003521f600" },
      { slug: "transferencias", title: "Transferencias", sisenseDashboardId: "67eebf36105c5800336ea1fb" },
    ],
  },
  {
    slug: "ordenes-de-compra",
    title: "Órdenes de Compra",
    icon: "📄",
    color: "#E11D48", // rose-600
    description:
      "Gestión de órdenes de compra: próximas a vencer, canceladas, consolidado y detalle para control y seguimiento.",
    dashboards: [
      { slug: "oc-por-vencer", title: "OC por Vencer", sisenseDashboardId: "622fc8e14f57c70036f6f30b" },
      { slug: "consulta-OC", title: "Consulta OC", sisenseDashboardId: "622fc3e54f57c70036f6f133" },
      { slug: "OC-canceladas", title: "OC Canceladas", sisenseDashboardId: "622fc7c34f57c70036f6f2eb" },
      { slug: "consolidado-OC", title: "Consolidado OC", sisenseDashboardId: "61bcb2a1588385002d13584f" },
      { slug: "detalle-OC", title: "Detalle OC", sisenseDashboardId: "621ee184e3243d002d0d55ef" },
    ],
  },
  {
    slug: "descargas",
    title: "Descargas",
    icon: "⬇️",
    color: "#0891B2", // cyan-600
    description:
      "Exportación de reportes operativos: venta diaria y mensual, inventario, fill rate y surtido.",
    dashboards: [
      { slug: "venta-diaria", title: "Venta Diaria", sisenseDashboardId: "5dfd4fec73cf33002bdda956" },
      { slug: "venta-mensual", title: "Venta Mensual", sisenseDashboardId: "5a622ebd0db48e1828be2b40" },
      { slug: "inventario", title: "Inventario", sisenseDashboardId: "5a7e2ba55b747918a04f390e" },
      { slug: "fill-rate", title: "Fill Rate", sisenseDashboardId: "627adb32a47a1000366f1810" },
      { slug: "surtido", title: "Surtido", sisenseDashboardId: "6267f753af04b6003743af79" },
    ],
  },
  {
    slug: "maestros",
    title: "Maestros",
    icon: "📋",
    color: "#475569", // slate-600
    description:
      "Consultas de maestros: catálogo de productos y estructura de organización para referencia y control.",
    dashboards: [
      { slug: "maestro-producto", title: "Maestro Producto", sisenseDashboardId: "5b3d0a497c1d432630906b69" },
      { slug: "maestro-organizacion", title: "Maestro Organización", sisenseDashboardId: "5dec492e6dcebf002b115587" },
    ],
  },
  {
    slug: "b2b",
    title: "B2B",
    icon: "🤝",
    color: "#1D4ED8", // blue-700
    description:
      "Portal B2B.",
    external: true,
    externalUrl: "https://b2b.unisupergt.com/ords/f?p=102",
    dashboards: [], // sin dashboards
  },
];

/** Helpers **/

export function moduleBySlug(slug) {
  return modules.find((m) => m.slug === slug);
}

export function dashboardBySlugs(moduleSlug, dashboardSlug) {
  const mod = moduleBySlug(moduleSlug);
  if (!mod || !mod.dashboards) return null;
  const index = mod.dashboards.findIndex((d) => d.slug === dashboardSlug);
  if (index === -1) return null;
  return {
    module: mod,
    dashboard: mod.dashboards[index],
    index,
    total: mod.dashboards.length,
  };
}

export function neighborDashboards(moduleSlug, dashboardSlug) {
  const found = dashboardBySlugs(moduleSlug, dashboardSlug);
  if (!found) return { prev: null, next: null };
  const { module, index } = found;
  const prev = module.dashboards[index - 1] || null;
  const next = module.dashboards[index + 1] || null;
  return { prev, next };
}

export function buildSisenseUrl({ host, dashboardId, query }) {
  const base = (host || SISENSE_HOST || "").replace(/\/$/, "");
  const params = new URLSearchParams({
    embed: "true",
    oidc: "true",
    auth: "oidc",
    ...(query || {}),
  });
  return `${base}/app/main/dashboards/${dashboardId}?${params.toString()}`;
}
